import * as urls from "../../../api/urls";
import React, { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import Loader from "components/Loader";
import MasterPage1Column from "pages/MasterPage1Column";
import LoadingIconWithText from "components/LoadingIconWithText";
import TextBox from "components/TextBox";
import classnames from "classnames";
import { useDialog } from "DialogProvider";
import { useCursorPopup, useRedux } from "hooks";
import { TaskStatus, WpEmpFilterType } from "../../../redux/workplace/wpTypes";
import { TaskRecurance2Data } from "types";
import SelectDropdown from "components/SelectDropdown";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';

interface MainComponentProps {
  onTaskCountChanged(taskCount: number): void;
}

// const MainComponent: React.FC<{ taskCount }> = ({ taskCount: number }) => {
const MainComponent = ({ onTaskCountChanged }: MainComponentProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<TaskRecurance2Data[]>([]);
  const [keyword, setKeyword] = useState<string>("");
  const [ddlRespondBy, setDdlRespondBy] = useState<any[]>([]);
  const [ddlDivision, setDdlDivision] = useState<any[]>([]);
  const [ddlSelectedRespondBy, setDdlSelectedRespondBy] = useState<any>();
  const [ddlSelectedDivision, setDdlSelectedDivision] = useState<any>();

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.GET_DLL_VALUE_TASK_RECURANCE_FILTER, { groupBy: "RespondBy" })
        .then(rs => setDdlRespondBy(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.GET_DLL_VALUE_TASK_RECURANCE_FILTER, { groupBy: "Division" })
        .then(rs => setDdlDivision(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    fnSearch();
  }, []);

  useEffect(() => {
    onTaskCountChanged((data ?? []).length);
  }, [data]);

  const fnSearch = async () => {
    setLoading(true);
    const parm = {
      keyword: keyword,
      responIds: ddlSelectedRespondBy ?? null, //.map(x => x.value).join("|"),
      divisionNames: ddlSelectedDivision ?? null, //.map(x => x.value).join("|")
    }
    new APIClient().fnPostForm(urls.WP_SEARCH_TASK_RECURANCE, parm)
      .then(rs => {
        // console.log('WP_SEARCH_TASK_RECURANCE:', rs);
        setData(rs);
        setLoading(false);
      })
      .catch(er => {
        Utils.HandleException(er, true);
        setLoading(false);
      });
  }

  useEffect(() => {
    fnSearch();
  }, [ddlSelectedRespondBy, ddlSelectedDivision]);

  const fnUpdateTask = async (taskId: string | null) => {
    if (taskId) {
      if (taskId.startsWith("del-")) {
        const keyRemove = taskId.replaceAll("del-", "");
        setData(prev => prev.filter(x => x.taskId !== keyRemove));
      } else { // update
        // console.log('update task id');
        new APIClient().fnPostForm(urls.WP_SEARCH_TASK_RECURANCE, { taskId: taskId })
          .then(rs => {
            if (rs.length === 1) {
              const tk = rs[0];
              setData(prev => {
                const exists = prev.some(t => t.taskId === tk.taskId);

                if (exists) {
                  return prev.map(x =>
                    x.taskId === tk.taskId ? tk : x
                  );
                } else {
                  return [...prev, tk];
                }
              });
            }
          });
      }
    }
  }

  // useEffect(() => {
  //   console.log('data:', data);
  // }, [data]);

  const dialog = useDialog();
  const fnEdit = async (taskId: string) => {
    const rsPostId = await dialog.showTaskRecurance({ postId: taskId, assignerEditable: true });
    await fnUpdateTask(rsPostId);
  }
  const fnAdd = async () => {
    const rsPostId = await dialog.showTaskRecurance({ assignerEditable: true });
    await fnUpdateTask(rsPostId);
  }

  const [subTask, setSubTask] = useState<any[]>([]);
  const [curTaskInPop, setCurTaskInPop] = useState<string>("");
  const [subTaskLoading, setSubTaskLoading] = useState<boolean>(false);
  const [showSubTaskDialog, setShowSubTaskDialog] = useState<boolean>(false);
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showSubTaskDialog,
    () => setShowSubTaskDialog(false)
  );

  const fnOnLoadChildTask = async (e: React.MouseEvent<HTMLElement>, taskId: string) => {
    setSubTaskLoading(true);
    setCurTaskInPop(taskId);
    try {
      openAtCursor(e);
      setShowSubTaskDialog(true);
      setSubTask([]);
      const rs = await new APIClient().fnPostForm(urls.WP_TK_LOAD_CHILD_TASK, { recuranceTaskId: taskId });
      // console.log(rs);
      setSubTask(rs);
    } catch (e) {
      Utils.HandleException(e, true);
    }
    setSubTaskLoading(false);
  }

  const minWidth = popCur.width < 720 ? "calc(100vw - 4px)" : "500px";

  const [createSubTaskCreating, setCreateSubTaskCreating] = useState<boolean>(false);
  const fnCreateChildTask = async () => {
    try {
      if (!curTaskInPop) {
        alert('No task selected yet');
      } else {
        const rs = await Utils.SweetConfirm('ต้องการสร้างงานถัดไปใหม่ จากรูปแบบการทำซักที่เลือก ใช่หรือไม่');
        if (rs.isConfirmed) {
          setCreateSubTaskCreating(true);
          const apiRs = await new APIClient().fnPostForm(urls.WP_TK_POST_FROM_RECURANCE, { recuranceTaskId: curTaskInPop });
          if (apiRs) {
            await fnSearch();
            setSubTask(prev => [apiRs, ...prev]);
          } else {
            alert('Cannot create child task');
          }
          console.log(apiRs);
        }
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
    setCreateSubTaskCreating(false);
  }

  const [goToPostChecking, setGoToPostChecking] = useState<string[]>([]);
  useEffect(() => {
    console.log(goToPostChecking);
  }, [goToPostChecking])
  const fnGoToPost = async (postId: string) => {
    // setGoToPostChecking(prev => [...prev, postId]);
    await Utils.Tk_OpenTask(postId, false, dispatch);
    // setGoToPostChecking(prev => prev.filter(x => x !== postId));

  }

  const Option = ({ data, isOption }: { data: any, isOption: boolean }) => {
    return (
      <div className="xyz12 d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
        <span className={isOption ? "ps-2" : ""}>{data.label}</span>
        <span className={isOption ? "pe-3" : ""}>{data.count}</span>
      </div>
    );
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (<components.Option {...props}><Option data={data} isOption={true} /></components.Option>);
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;
    return (<components.SingleValue {...props}><Option data={data} isOption={false} /></components.SingleValue>);
  };

  return (
    <div>
      {showSubTaskDialog && (
        <div ref={popRef} className="context-container d-flex" style={{ flexDirection: "column", zIndex: "9", minWidth: minWidth, minHeight: "200px", maxWidth: "calc(100vw - 60px)", position: "fixed", top: popCur.y, left: popCur.x }}>
          {subTaskLoading && (<Loader />)}
          <div className="d-flex " style={{ gap: "8px", flexDirection: "column" }}>
            {!subTaskLoading && subTask?.map((task: any, index: number) => {
              const isGoingToPost = goToPostChecking.includes(task.taskId);
              // console.log('isGoingToPost:', { isGoingToPost, goToPostChecking, taskId: task.taskId });
              return (
                <div key={index} className="hover hand d-flex justify-content-between align-items-center" onClick={(e) => isGoingToPost ? null : fnGoToPost(task.taskId)}>
                  <div className="d-flex align-items-center">
                    {isGoingToPost && (<LoadingIconWithText loadingText={""} />)}
                    {!isGoingToPost && (<>{Utils.GetTaskStatusIcon(task.status ?? TaskStatus.ToDo)}</>)}
                    {task.taskName}
                  </div>
                  <span >
                    {Utils.GetDMYHHMM(task.createDate)}
                  </span>
                </div>
              )
            })}
          </div>
          <div style={{ marginTop: "auto", marginBottom: "4px" }}>
            <div className="d-flex justficy-content-between gap-2">
              <button className="btn2 btn2-danger fz-10 btn-outline-primary" style={{ border: "solid 1px gray" }} title="สร้างงานขึ้นมาใหม่ ตามรูปแบบที่ตั้งค่าไว้" onClick={() => createSubTaskCreating ? null : fnCreateChildTask()}>
                {createSubTaskCreating && (<LoadingIconWithText loadingText={"กำลังสร้าง...."} />)}
                {!createSubTaskCreating && (<span title="สร้างงานถัดไป จากรูปแบบนี้">✨</span>)}
              </button>
              <button className="btn2 btn2-warning flex-grow-1" onClick={(e) => setShowSubTaskDialog(false)}>ปิด</button>
            </div>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
        <div className="row " style={{ flexGrow: "1" }}>
          <div className="col">
            <TextBox placeholder="ชื่อ งาน/เจ้าของงาน/หน่วยงาน" onClear={fnSearch} style={{ padding: "5px" }} icon13css="fas fa-search fz-10 me-1" value={keyword} onChange={(e) => setKeyword(e.target.value)} onEnter13={fnSearch} />
          </div>
          <div className="col">
            <SelectDropdown
              isDisabled={false}
              list={ddlRespondBy}
              selectedValue={ddlRespondBy.find(x => x.value == ddlSelectedRespondBy)}
              onValueChanged={(e) => { setDdlSelectedRespondBy(e); console.log(e) }}
              customOption={CustomOption}
              customValue={CustomSingleValue}
              placeholder={"เจ้าของงาน"}
              isMulti={false}
            />
          </div>
          <div className="col">
            <SelectDropdown
              isDisabled={false}
              list={ddlDivision}
              selectedValue={ddlDivision.find(x => x.value == ddlSelectedDivision)}
              onValueChanged={(e) => setDdlSelectedDivision(e)}
              customOption={CustomOption}
              customValue={CustomSingleValue}
              placeholder={"หน่วยงาน"}
              isMulti={false}
            />
          </div>
        </div>
        <div className="input-group-append">
          <button className="btn btn-warning" type="submit" onClick={fnAdd}>เพิ่ม</button>
        </div>
      </div>
      <div style={{ height: "5px" }}></div>
      {loading && (<Loader />)}
      <div className="div-table-fix-header" style={{ height: "calc(100vh - 120px)" }}>
        <table >
          <thead >
            <tr>
              <th>ชื่องาน</th>
              <th>ความถี่</th>
              <th>เจ้าของงาน</th>
              {/* <th>วันสร้างงาน ถัดไป</th>*/}
              <th>สถานะ</th>
              <th>กำหนดเสร็จ</th>
              <th>งานที่สร้างแล้ว</th>
              <th>คำสั่ง</th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length <= 0 && (<tr><td align="center" colSpan={7}>ไม่มีข้อมูล</td></tr>)}
            {/* {loading && (<tr><td align="center" colSpan={6}><LoadingIconWithText loadingText={""}></LoadingIconWithText> กำลังค้นหา</td></tr>)} */}
            {data.map((tk, index) => {
              // let frequency = tk.recuranceMode;
              // switch (tk.recuranceMode) {
              //   case RecuranceModes.Daily: frequency = "ทุกวัน"; break;
              //   case RecuranceModes.Monthly: frequency = "ทุกเดือน"; break;
              //   case RecuranceModes.None: frequency = ""; break;
              //   case RecuranceModes.OneTime: frequency = "ครั้งเดียว"; break;
              //   case RecuranceModes.Weekly: frequency = "ทุกอาทิตย์"; break;
              //   case RecuranceModes.Yearly: frequency = "ทุกปี"; break;
              // }
              const frequency = Utils.GetTaskRecuranceFreqText(tk as TaskRecurance2Data);
              const freqException = Utils.GetTaskRecuranceExceptionText(tk as TaskRecurance2Data);
              // const frequency = tk.recuranceText;
              const taskStatus = Utils.GetTaskStatusFromVal(Utils.GetTaskStatusFromVal(tk.lastTaskStatus ?? null));
              const taskIcon = Utils.GetTaskStatusIcon(taskStatus);
              const taskStatusName = Utils.GetTaskStatusText(taskStatus);
              const taskDueName = Utils.GetTaskStatusFromOverdueDateText(taskStatus, Utils.ToNumber(tk.lastTaskOverdueDay, null), Utils.ToNumber(tk.upcomingDayCal, null));// Utils.GetTaskStatusText(taskStatus);
              const taskStatusTss =
                taskStatus === TaskStatus.Finished ? 'task-due-success'
                  : taskStatus === TaskStatus.Cancel ? 'task-due-cancel'
                    : ('task-due-' + Utils.GetTaskStatusFromOverdueDateCss(tk.lastTaskOverdueDay ?? null));
              const isGoingToPost = goToPostChecking.includes(tk.taskId ?? "");
              return (
                <tr key={index} className={classnames("hover", { "text-gray": !tk.enabled })} >
                  <td >
                    {tk.isSomePersonInActive == true && (<i className="fas fa-user-circle text-danger me-1" title="ผู้เกี่ยวข้องในงาน อยู่ในสถานะไม่ active&#10;กรุณาตรวจเช็ค เพื่อให้มั่นใจว่างานมีผู้ดูแล"></i>)}
                    {tk.lastTaskName ?? tk.taskName}
                  </td>
                  <td >{frequency}{freqException && (<>&nbsp;{freqException}</>)}</td>
                  <td >{tk.respondName}</td>
                  {/* <td >
                    {tk.nextDateCreateTask1 && (
                      <div className="d-flex justify-content-between">
                        <span>{Utils.GetDMYHHMM(tk.nextDateCreateTask1)}</span>
                        <span>อีก {tk.upcomingDayCal} วัน</span>
                      </div>
                    )}
                  </td> */}
                  <td onClick={() => isGoingToPost ? null : fnGoToPost(tk.lastActiveTask ?? "")} >
                    <div className={"d-flex justify-content-between task-due " + taskStatusTss} >
                      <div>
                        {isGoingToPost && (<LoadingIconWithText loadingText={""} />)}
                        {!isGoingToPost && (<>{taskIcon}</>)}
                        {taskStatusName}
                      </div>
                      <div>{taskDueName}</div>
                    </div>
                  </td>
                  <td >{Utils.GetDMY(tk.lastTaskPlanFinishedDate)}</td>
                  <td onClick={(e) => fnOnLoadChildTask(e, tk.taskId!)}>{Utils.FormatNumber(tk.taskCreated, 0)}</td>
                  <td align="center">
                    <div className="d-flex justify-content-center" style={{ gap: "4px" }}>
                      <button title="แก้ไข" className="btn btn-outline-primary fz-11 pt-0 pb-0" onClick={() => fnEdit(tk.taskId!)}>
                        <i className="fas fa-pencil-alt fz-09"></i><span className="hide-xl-bellow">แก้ไข</span>
                      </button>
                      <button title="ดูตารางงานถัดไป" className="btn btn-outline-primary fz-11 pt-0 pb-0" onClick={async () => await Utils.ShowNextTaskRecuranceTable(tk)}>
                        <i className="fa fa-hourglass-1 fz-09"></i><span className="hide-xl-bellow"> งานถัดไป</span>
                      </button>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const DataSettingTaskRecurance = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  const [taskCount, setTaskCount] = useState<number>(0);

  const onTaskCountChanged = (taskCount: number) => {
    setTaskCount(taskCount);
  };

  return (
    <MasterPage1Column
      titleText={"รายการงานประจำ" + (taskCount <= 0 ? "" : (` ${taskCount} งาน`))}
      titleIcon="fab fa-digital-ocean"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<MainComponent onTaskCountChanged={onTaskCountChanged} />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingTaskRecurance;